import React from "react";
import { AHText, Box } from "arkh";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSizeClass } from "../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

import { graphql, useFragment } from "react-relay";
import { SignalDetailFooter_signal$key } from "./__generated__/SignalDetailFooter_signal.graphql";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";

import { SignalOpenedByEmployeeButton } from "./SignalOpenedByEmployeeButton";

export function SignalDetailFooter(props: {
  openSeenBy: () => void;
  openSeenByEmployee: () => void;
  signal: SignalDetailFooter_signal$key;
}) {
  const signal = useFragment(
    graphql`
      fragment SignalDetailFooter_signal on Signal {
        opened

        ...SignalOpenedByEmployeeButton_signal
      }
    `,
    props.signal
  );
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const insets = useSafeAreaInsets();
  const intl_tokens = useIntlTokens();

  return (
    <Box
      color="surface-primary"
      space="medium"
      insets={{
        bottom: isCompact ? insets.bottom : 0,
      }}
      style={{
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      {signal.opened ? (
        <AHText type="subtitle" color="text-secondary" style={{ flex: 1 }}>
          {intl_tokens.Opened}
        </AHText>
      ) : null}

      <SignalOpenedByEmployeeButton
        signal={signal}
        onPress={props.openSeenByEmployee}
      />
    </Box>
  );
}
